import { Component, OnInit } from '@angular/core';
import { IonicPage, ViewController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
/**
 * Generated class for the SelectPrestartItemsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-select-prestart-items',
  templateUrl: 'select-prestart-items.html',
})
export class SelectPrestartItemsPage implements OnInit {
  itemList = [];
  isNoData = false;
  show = false;
  text:any = "";
  constructor(
    public viewCtrl: ViewController,
    private api: CrudProvider,
    private utiltiy: UtiltiyProvider
    ) {
  }
  ngOnInit() {
  }
  ionViewDidLoad() {
    
    console.log("--",this.viewCtrl.data)

    if(this.viewCtrl.data.isKlmr){
      this.show = true;
    }
    if(this.viewCtrl.data.list.length){
      this.itemList = this.viewCtrl.data.list;
      return;
    }
    if(this.viewCtrl.data.fleetId){
      this.utiltiy.startLoading();
      let formData: FormData = new FormData();
      formData.append("method_name", "prestart_items");
      formData.append("fleet_no", this.viewCtrl.data.fleetId);
      let baseUrl =  this.show?'/prestart/jobcard':'/tansix_prestart/jobcard';
      this.api.post(baseUrl , false ,formData ).then((res: any)=>{
        console.log(res);
        if(res.message === 'No Data Found'){
          this.isNoData = false;

          let newArray = [];
          this.viewCtrl.data.selectedList.forEach(element => {
            let i = this.itemList.findIndex(list_ => list_.id == element.id);
            console.log(i,"--",element)
            if(i != -1){
              this.itemList[i] = element;
              this.itemList[i].isChecked = true;
              newArray.push(this.itemList[i]);
            }else{
              element.isChecked = true;
              newArray.push(element);
            }

            // this.viewCtrl.data.selectedList
          });

          this.itemList.forEach(element => {
            let i =  this.viewCtrl.data.selectedList.findIndex(list_ => list_.id == element.id);
            console.log(i,"--",element)
            if(i == -1){
              newArray.push(element);
            }
            // this.viewCtrl.data.selectedList
          });


         
          console.log("this.itemList",newArray)

          this.itemList = this.viewCtrl.data.selectedList.length == 0?this.itemList:newArray

          this.utiltiy.stopLoading();
        }
        else{
          this.isNoData  = false;
          // res.result[0].vehicles = this.show?res.result[0].vehicles:[];
          res.result[0].vehicles.forEach((element)=>{
            if(element.id != 0){
              const data = {
                isChecked: false,
                title: element.name,
                id: element.id,
                comment: "",
                file: "",
                completed_by: "", 
                completed_name: [], 
                base64: true,
                dbId: null,
                imagePrefix:"",
                isCheck:false,
                isBase64:false,
                finalBase64:null,
              }
              this.itemList.push(data);
            }
          }); 
         let newArray = [];
          this.viewCtrl.data.selectedList.forEach(element => {
            let i = this.itemList.findIndex(list_ => list_.id == element.id);
            console.log(i,"--",element)
            if(i != -1){
              this.itemList[i] = element;
              this.itemList[i].isChecked = true;
              newArray.push(this.itemList[i]);
            }else{
              element.isChecked = true;
              newArray.push(element);
            }

            // this.viewCtrl.data.selectedList
          });

          this.itemList.forEach(element => {
            let i =  this.viewCtrl.data.selectedList.findIndex(list_ => list_.id == element.id);
            console.log(i,"--",element)
            if(i == -1){
              newArray.push(element);
            }
            // this.viewCtrl.data.selectedList
          });


         
          console.log("this.itemList",newArray)

          this.itemList = this.viewCtrl.data.selectedList.length == 0?this.itemList:newArray
          console.log("this.itemList",this.itemList)
          this.utiltiy.stopLoading();
        }
      }).catch((error)=>{
        console.log(error);
        // this.isNoData = true;
        this.utiltiy.stopLoading();
      })
    }else{
      this.isNoData = true;
    }
  }

  submit(){
    if(this.itemList.length != 0 ){
      this.viewCtrl.dismiss(this.itemList)
    }else{
      this.utiltiy.toaster("Add item");
    }
    console.log("this.itemList",this.itemList)

  }

  closeModal(){
    this.viewCtrl.dismiss(false)
  }

  addNew(){
    if(this.text.length != 0){

      const data = {
        isChecked: false,
        title: this.text,
        id: this.text,
        comment: "",
        file: "",
        completed_by: "", 
        completed_name: [], 
        base64: true,
        dbId:null,
        imagePrefix: "",
        isCheck:false,
        isBase64:false,
        finalBase64:null,

      };
      this.itemList.push(data);
      this.text = "";
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-prestart-items/select-prestart-items.ts